'use client';

// ─────────────────────────────────────────────────────────────
// 全域錯誤邊界 (global-error)
//
// 僅在「根佈局 app/layout.tsx 本身」渲染失敗時觸發 —— 此時根佈局
// （含 <html>/<body> 與 globals.css）已不可用，故本檔須自帶
// <html>/<body> 並用內聯樣式，不依賴任何外部樣式或元件。
//
// 一般業務頁的錯誤由 app/error.tsx 與 app/(main)/error.tsx 兜底，
// 不會走到這裡。
// ─────────────────────────────────────────────────────────────

import { useEffect } from 'react';
import { reportError } from '@/lib/reportError';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, 'global-error');
  }, [error]);

  return (
    <html lang="zh-TW">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          /* 不指定字型，用瀏覽器預設字型（全站一致，見 globals.css） */
          color: '#404040',
          background: '#fff',
        }}
      >
        <p style={{ fontSize: '18px', fontWeight: 600 }}>頁面出了點問題</p>
        <p style={{ fontSize: '14px', color: '#737373' }}>請重新整理頁面後再試</p>
        <button
          type="button"
          onClick={reset}
          style={{
            padding: '8px 20px',
            fontSize: '14px',
            color: '#fff',
            background: '#f97316',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          重試
        </button>
      </body>
    </html>
  );
}
